import React from 'react';

export const Footer: React.FC = () => (
  <footer>
    <span className="ft-copy">
      © {new Date().getFullYear()} Don Jayasinghe. All rights reserved.
    </span>
    <span className="ft-stack">Built with React + TypeScript</span>
  </footer>
);
